import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow 
} from "@/components/ui/table";
import { History, TrendingUp, AlertTriangle } from 'lucide-react';

const orders = [
  { po: 'PO-SUP-OT-PIL-C1', cycle: 'Pilot C1', books: 300, titles: 30, value: 4860, dispatched: 'Jul 2026', received: true, invoice: 'INV-OT-PIL-001', invoiceStatus: 'paid' },
  { po: 'PO-SUP-OT-PIL-C2-NOV', cycle: 'Pilot C2', books: 100, titles: 20, value: 1620, dispatched: 'Nov 2026', received: true, invoice: 'INV-OT-PIL-C2-NOV', invoiceStatus: 'paid' },
  { po: 'PO-SUP-OT-MK-2026', cycle: 'MK 2026', books: 360, titles: 20, value: 4320, dispatched: 'Sep 2026', received: true, invoice: 'INV-OT-MK-2026', invoiceStatus: 'paid' },
  { po: 'PO-SUP-OT-CDS-C1', cycle: 'CDS Cycle 1', books: 4820, titles: 38, value: 78246, dispatched: 'Oct 2027', received: false, invoice: '—', invoiceStatus: 'upcoming' },
];

export default function SupplierOrderHistory() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900 flex items-center gap-3">
          <History className="w-7 h-7 text-[#7A4020]" />
          Order History & Performance Analytics
        </h1>
      </div>

      {/* Fulfilled Orders */}
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Fulfilled Orders</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>PO</TableHead>
                <TableHead>Cycle</TableHead>
                <TableHead>Books</TableHead>
                <TableHead>Titles</TableHead>
                <TableHead>Value</TableHead>
                <TableHead>Dispatched</TableHead>
                <TableHead>Civica Receipt</TableHead>
                <TableHead>Invoice</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.map((order, idx) => (
                <TableRow key={idx} className="table-row-striped">
                  <TableCell className="font-mono text-xs">{order.po}</TableCell>
                  <TableCell>{order.cycle}</TableCell>
                  <TableCell>{order.books.toLocaleString()}</TableCell>
                  <TableCell>{order.titles}</TableCell>
                  <TableCell>${order.value.toLocaleString()}</TableCell>
                  <TableCell>{order.dispatched}</TableCell>
                  <TableCell>
                    {order.received ? (
                      <Badge className="bg-emerald-50 text-emerald-700">✓</Badge>
                    ) : (
                      <Badge variant="outline">⏳ Upcoming</Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {order.invoiceStatus === 'paid' ? (
                      <Badge className="bg-emerald-50 text-emerald-700">{order.invoice} ✓ Paid</Badge>
                    ) : (
                      <span className="text-slate-400">{order.invoice}</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {/* Out of Stock Incidents */}
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Out-of-Stock Incidents Log</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="p-4 border rounded-lg">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5" />
              <div>
                <p className="font-medium">"Body & Mind: Teen Guide"</p>
                <p className="text-sm text-slate-500">Issue: Out of print</p>
                <p className="text-sm text-slate-600">Alternative Source: Kinokuniya + Amazon</p>
                <p className="text-sm text-emerald-600">
                  Cost Absorbed: $0.20/copy × 287 = $57.40 absorbed by OT ✓
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Performance Dashboard */}
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Performance Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-4 bg-emerald-50 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <TrendingUp className="w-5 h-5 text-emerald-600" />
                <span className="text-sm text-emerald-700">Quote Win Rate</span>
              </div>
              <div className="text-2xl font-bold text-emerald-700">76.5%</div>
              <p className="text-sm text-emerald-600">52/68 titles</p>
            </div>

            <div className="p-4 bg-emerald-50 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <TrendingUp className="w-5 h-5 text-emerald-600" />
                <span className="text-sm text-emerald-700">On-Time Delivery</span>
              </div>
              <div className="text-2xl font-bold text-emerald-700">100%</div>
              <p className="text-sm text-emerald-600">Pilot phase ✓</p>
            </div>

            <div className="p-4 bg-emerald-50 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <TrendingUp className="w-5 h-5 text-emerald-600" />
                <span className="text-sm text-emerald-700">Stock Accuracy</span>
              </div>
              <div className="text-2xl font-bold text-emerald-700">98.2%</div>
              <p className="text-sm text-emerald-600">Excellent</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
